<template>
  <div style="margin-bottom:56px;" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img src="@/assets/img/carbon/hongly-logo.png" alt="弘绿元..." />
      </div>
      <div class="navbar_right">
        <div class="nav_tiyan" @click="gotoExperience">{{ $t('nav.startTrial') }}</div>
        <div class="nav_language" @click="switchLanguage">{{ currentLang === 'zh' ? 'EN' : '中文' }}</div>
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <Affix>
      <div class="nav_menu" ref="menu">
        <div
          class="menu_item"
          @click="changeProductShow"
          :class="currentActive === 1 ? 'active' : ''"
        >
          {{ $t('nav.aboutus') }}
        </div>
        <div class="item_options" v-show="productShow">
          <router-link to="/aboutUs" @click.native="handleMenuItemClick">{{ $t('nav.aboutusInfo') }}</router-link>
          <router-link to="/newsCenter" @click.native="handleMenuItemClick">{{ $t('nav.newsCenter') }}</router-link>
          <router-link to="/joinUs" @click.native="handleMenuItemClick">{{ $t('nav.joinus') }}</router-link>
          <router-link to="/trial" @click.native="handleMenuItemClick">{{ $t('nav.consultnow') }}</router-link>
        </div>
        <router-link
          class="menu_item"
          to="/SustainableSupplyChainCloud"
          :class="currentActive === 2 ? 'active' : ''"
          >{{ $t('nav.ssccp') }}</router-link
        >
        <router-link
          class="menu_item"
          to="/toolCloud"
          :class="currentActive === 3 ? 'active' : ''"
          >{{ $t('nav.toolCloud') }}</router-link
        >
        <router-link
          class="menu_item"
          to="/training"
          :class="currentActive === 4 ? 'active' : ''"
          >{{ $t('nav.onlineTraining') }}</router-link
        >
         <!-- <div
          class="menu_item"
          @click="changeOnlineShow"
          :class="currentActive === 4 ? 'active' : ''"
        >
          {{ $t('nav.onlineTraining') }}
        </div> -->
        <!-- <div class="item_options" v-show="onlineShow">
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.ociit') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.pcft') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.ESGmtapt') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.eat') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.emsiat') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.iatfems') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.ISCC') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.ecovadisTraining') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.cbamTraining') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.euBatteryTraining') }}</router-link>
          <router-link to="/" @click.native="handleMenuItemClick">{{ $t('nav.ctc') }}</router-link>
        </div> -->
      </div>
    </Affix>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      productShow: false,
      centerShow: false,
      fireShow: false,
      onlineShow: false,
      currentLang: localStorage.getItem('language') || 'zh'
    }
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  methods: {
    handleMenuItemClick(){
      this.productShow = false;
      this.centerShow = false;
      this.fireShow = false;
      this.menuShow = false;
      this.$refs.menu.style.top = '-1000PX';
    },
    switchLanguage() {
      const newLang = this.currentLang === 'zh' ? 'en' : 'zh';
      this.currentLang = newLang;
      this.$i18n.locale = newLang;
      localStorage.setItem('language', newLang);
    },
    moveMenu() {
      this.menuShow = !this.menuShow
      if (this.menuShow) {
        this.$refs.menu.style.top = '56PX'
      } else {
        this.$refs.menu.style.top = '-1000PX'
      }
    },
    changeProductShow() {
      this.productShow = !this.productShow
      this.centerShow = false
      this.fireShow = false
    },
    changeOnlineShow() {
      this.onlineShow = !this.onlineShow
      this.centerShow = false
      this.fireShow = false
      this.productShow = false
    },
    changeCenterShow() {
      this.centerShow = !this.centerShow
      this.fireShow = false
      this.productShow = false
    },
    changefireShow() {
      this.fireShow = !this.fireShow
      this.centerShow = false
      this.productShow = false
    },
    gotoExperience() {
      this.$router.push('/trial').catch((v) => {})
    },
    toRedc() {
      window.open('https://redc.carbon-tc.com/', '_blank')
    },
    gobackHome(){
      this.$router.replace('/home').catch((v) => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56PX;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15PX 0 15PX 15PX;
  align-items: center;
  position: fixed;
  top: 0;
  .navbar_left {
    flex: 1;
    background: #fff;
    img {
      margin-left: 2rem;
      width: 40%;
    }
  }
  .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    background: #fff; 
    .nav_tiyan {
      width: 88PX;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
    }
    .nav_loginRedc {
      width: 66PX;
      padding: 0 10PX;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
      margin-left: 0.2rem;
    }
    .nav_language {
      width: 50PX;
      height: 100%;
      background: #f29c11;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
      // margin-right: 0.5rem;
    }

    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 30PX;
      }
    }
  }
}
.active{
  color: #F39C00 !important;
  font-weight: bold;
}
.nav_menu{
    position: absolute;
    width: 100%;
    height: 450PX;
    list-style: none;
    left: 0;
    right: 0;
    top: -1000PX;
    padding-bottom: 0;
    box-sizing: border-box;
    background: #EFF0F1;
    box-shadow: 0 10PX 20PX rgba(0,0,0,.1);
    z-index: 10;
    transition: all 0.8s;
    .menu_item{
      width: 100%;
      height: 40PX;
      font-size: 16PX;
      background: #EFF0F1;
      color: #1c212d;
      padding: 30PX;
      display: flex;
      align-items: center;
    }
    .item_options{
      width: 100%;
      padding: 5PX 10PX;
      font-size: 14PX;
      background: #fff;
      a{
        display: inline-block;
        width: 100%;
        color: #666;
        height: 25%;
        padding: 20px 30PX;
      }
    }
  }
.disabled-link {
  pointer-events: none;     /* 禁止点击 */
  color: gray;              /* 置灰 */
  opacity: 0.6;             /* 降低不透明度 */
  cursor: not-allowed;      /* 显示禁用样式 */
  text-decoration: none;    /* 去掉下划线（可选） */
}
</style>